<template>
    <div class="inline-flex">
        <div @click="openModal" class="btn btn-sm btn-blue">
            Reset
        </div>
        <modal @close="close" v-if="showModal">
            <template #header>
                <div class="text-yellow-500">
                    <i class="fas fa-exclamation-circle mr-1"></i>Reset Chart
                </div>
            </template>
            <template #body>
                <div class="py-4">
                    <div class="mb-3">
                        Select the data to reset/clear from this chart
                    </div>
                    <div>
                        <label for="all">
                            <input class="form-control mr-1" id="all" type="radio" name="type" value="all" v-model="type">
                            Reset all settings, remove indicators, and tools
                        </label>
                    </div>
                    <div>
                        <label for="tools">
                            <input class="form-control mr-1" id="tools" type="radio" name="type" value="tools" v-model="type">
                            Remove ONLY tools
                        </label>
                    </div>
                </div>
            </template>
            <template #footer>
                <div class="flex justify-center">
                    <div class="btn btn-sm btn-yellow-ghost inline-flex mx-1" @click="close">Cancel</div>
                    <div class="btn btn-sm btn-yellow inline-flex mx-1" @click="reset">Reset</div>
                </div>
            </template>
        </modal>
    </div>
</template>

<script setup>
import { ref } from 'vue';

const showModal = ref(false);
const type = ref('all');

const emit = defineEmits(['reset']);

const openModal = () => {
    showModal.value = true;
};

const reset = () => {
    emit('reset', type.value);
    close();
};

const close = () => {
    showModal.value = false;
};

defineExpose({ openModal });
</script>
